const FailurePage = () => {
    return (
        <div style={{ backgroundColor: "darkred", display: "flex", flexDirection: 'column', height: "100vh" }}>
            <link
                href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.0/css/bootstrap.min.css"
                rel="stylesheet"
                id="bootstrap-css"
            />
            <div className="jumbotron text-center" style={{ backgroundColor: 'darkred', color: 'white', display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <h1 className="display-3">Error!</h1>
                <p className="lead"><strong>Something unexpected happened</strong></p>
                <hr />
                <p>
                    Having trouble? <a href="#">Contact us</a>
                </p>
            </div>
        </div>
    );
}

export default FailurePage;